<script setup>
import KdContainer from "./kdContainer.vue";

</script>

<template>
  <kd-container>
    <el-form :model="form" :rules="rules" ref="formRef" label-width="145px">
      <div v-for="(sItem, index) in form.suggestionItems" :key="index">
        <div class="suggestionTitle">
          <div>{{ sItem.staffName }}</div>
        </div>
        <div>

          <el-form-item label="临时措施" prop="`suggestionItems.${index}.provisionalMeasures`">
            <el-input v-model="sItem.provisionalMeasures" type="textarea" placeholder="请输入临时措施" disabled :autosize="{ minRows: 4, maxRows: 4 }" maxlength="500" show-word-limit></el-input>
          </el-form-item>

          <el-form-item
            :prop="`suggestionItems.${index}.provisionalMeasuresFile`"
          >
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.provisionalMeasuresFile"
            ></file-upload-list>
          </el-form-item>

          <el-form-item
            label="永久方案"
            :prop="`suggestionItems.${index}.permanentSolution`"
            :rules="rules.permanentSolution"
          >
            <el-input
              :disabled="sItem && sItem.permanentSolution !== ''"
              placeholder="请输入永久方案"
              v-model="sItem.permanentSolution"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            :prop="`suggestionItems.${index}.permanentSolutionFile`"
          >
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.permanentSolutionFile"
            ></file-upload-list>
          </el-form-item>
          <el-form-item
            label="计划断点时间"
            :prop="`suggestionItems.${index}.planBreakpointTime`"
            :rules="rules.planBreakpointTime"
          >
            <el-date-picker
              :disabled="sItem && sItem.planBreakpointTime !== ''"
              v-model="sItem.planBreakpointTime"
              type="date"
              placeholder="请选择计划断点时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="完成情况"
            :prop="`suggestionItems.${index}.finishStatusInfo`"
            :rules="rules.finishStatusInfo"
          >
            <el-input
              :disabled="sItem && sItem.finishStatusInfo !== ''"
              placeholder="请输入完成情况"
              v-model="sItem.finishStatusInfo"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item
            label="实际断点时间"
            :prop="`suggestionItems.${index}.realityBreakpointTime`"
            :rules="rules.realityBreakpointTime"
          >
            <el-date-picker
              :disabled="sItem && sItem.realityBreakpointTime !== ''"
              v-model="sItem.realityBreakpointTime"
              type="date"
              placeholder="请选择实际断点时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            :prop="`suggestionItems.${index}.finishStatusInfoFiles`"
          >
            <file-upload-list
              ref="fileUploadList"
              :fileList="sItem.finishStatusInfoFiles"
            ></file-upload-list>
          </el-form-item>


          <div v-if="taskDefKey == 'Activity_157te0n' || taskDefKey == 'Activity_1pp3lzj' || taskDefKey == 'Activity_13bppvj'">
            <el-form-item
              label="技术经理验证情况"
              :prop="`suggestionItems.${index}.checkStatusInfo`"
              :rules="rules.checkStatusInfo"
            >
              <el-input
                v-model="sItem.checkStatusInfo"
                :disabled="sItem && sItem.practicalBreakpointTime !== ''"
                type="textarea"
                placeholder="请输入验证情况"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
          </div>
          <div v-else>
            <el-form-item
              label="QE验证情况"
              :prop="`suggestionItems.${index}.checkStatusInfo`"
              :rules="rules.checkStatusInfo"
            >
              <el-input
                v-model="sItem.checkStatusInfo"
                :disabled="sItem && sItem.practicalBreakpointTime !== ''"
                type="textarea"
                placeholder="请输入验证情况"
                :autosize="{ minRows: 4, maxRows: 4 }"
                maxlength="500"
                show-word-limit
              ></el-input>
            </el-form-item>
            </div>
          <el-form-item
            label="验证断点时间"
            :prop="`suggestionItems.${index}.practicalBreakpointTime`"
            :rules="rules.practicalBreakpointTime"
          >
            <el-date-picker
              :disabled="sItem && sItem.practicalBreakpointTime !== ''"
              v-model="sItem.practicalBreakpointTime"
              type="date"
              placeholder="请选择断点时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <file-upload-list
              v-if="sItem && sItem.checkStatusInfoFiles !== ''"
              ref="fileUploadList"
              :fileList="sItem.checkStatusInfoFiles"
            ></file-upload-list>
            <drag-upload
              v-else
              ref="uploadFile"
              :accessoryList.sync="sItem.checkStatusInfoFiles"
              :httpRequest="imAction"
            />
          </el-form-item>
        </div>
      </div>

      <el-form-item>
        <el-button class="lang-but" type="primary" @click="auditPassBtClick"
          >通过</el-button
        >
        <el-button class="lang-but" type="danger" @click="auditRejectBtClick"
          >驳回</el-button
        >
      </el-form-item>
    </el-form>

    <kd-audit-pass-dialog
      :visible.sync="auditPassDialogVisible"
      v-model="form.auditText"
      @confirm="onAuditPassConfirm"
    />

    <div>
      <el-dialog
        width="600px !important"
        title="审核驳回"
        :visible.sync="dialogVisible"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="rejectFormRef"
          label-width="85px"
        >
          <el-form-item label="驳回原因" prop="rejectReason">
            <el-input
              v-model="form.rejectReason"
              type="textarea"
              placeholder="请输入驳回原因"
              :autosize="{ minRows: 4, maxRows: 4 }"
              maxlength="500"
              show-word-limit
            ></el-input>
          </el-form-item>
          <div class="submitArea">
            <el-button type="primary" @click="auditRejectSubmit()"
              >提交</el-button
            >
            <el-button plain @click="dialogVisible = false">取消</el-button>
          </div>
        </el-form>
      </el-dialog>
    </div>
  </kd-container>
</template>

<style scoped lang="scss"></style>
<script>
import { baseURL } from "../../util/url";
import { requestSubmitAuditKD } from "@/api/feedbackKD";
import KdAuditPassDialog from "./kdAuditPassDialog.vue";

/**
 * 18.2-市场工程师审核
 * 19.2-质量改善部部长审核
 * 20.2-质量经理审核
 */
export default {
  name: "kdMarketEngineerAudit",
  components: { KdAuditPassDialog },
  props: {
    taskId: String,
    questionId: String,
    taskDefKey: String,
    suggestionItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      header: {
        satoken: sessionStorage.getItem("token"),
      },
      hasFileEchoShow: false,
      imAction: "/manage/staff/upload?fileType=auditResource",
      dialogVisible: false,
      auditPassDialogVisible: false,
      form: {
        suggestionItems: [
          {
            userId: "",
            hasReasonAnalystMaterial: "",
            practicalBreakpointTime: "",
            reasonAnalyst: "",
            checkStatusInfo: "",
            checkStatusInfoFiles: [],
            reasonAnalystMaterial: "",
            planBreakpointTime: "",
            permanentSolution: "",
            permanentSolutionFile: [],
            provisionalMeasuresFile: [],
            finishStatusInfo: "",
            finishStatusInfoFiles: [],
            file: [],
          },
        ],
        rejectReason: "",
        auditText: "",
      },
      rules: {
        permanentSolution: [
          {
            required: true,
            message: "永久方案不能为空",
            trigger: ["blur", "change"],
          },
        ],
        planBreakpointTime: [
          {
            required: true,
            message: "实际断点时间不能为空",
            trigger: ["blur", "change"],
          },
        ],
        finishStatusInfo: [
          {
            required: true,
            message: "完成情况不能为空",
            trigger: ["blur", "change"],
          },
        ],
        checkStatusInfo: [
          { required: true, message: "验证情况不能为空", trigger: ["blur"] },
        ],
        practicalBreakpointTime: [
          {
            required: true,
            message: "断点时间不能为空",
            trigger: ["blur", "change"],
          },
        ],
        rejectReason: [
          {
            required: true,
            message: "驳回原因不能为空",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  watch: {
    hasTempSolution: function (val) {
      this.$emit("hasTempSolution", val);
    },
  },
  methods: {
    auditPassBtClick() {
      this.$refs["formRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        this.auditPassDialogVisible = true;
      });
    },
    onAuditPassConfirm(auditText) {
      let formData = {
        nowTaskId: this.taskId,
        questionId: this.questionId,
        taskDefKey: this.taskDefKey,
        auditText: auditText,
        variables: {
          approval: true,
        },
      };
      requestSubmitAuditKD(formData).then((res) => {
        if (res.status == "0") {
          this.$DonMessage.success("审批通过!");
          this.backRouterPath();
        }else {
          this.$DonMessage.error(res.message);
        }
      });
    },
    auditRejectBtClick() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.rejectFormRef?.resetFields();
      });
    },
    auditRejectSubmit() {
      this.$refs["rejectFormRef"].validate((valid, object) => {
        if (this.getRequiredValid(valid, object)) {
          return;
        }
        let formData = {
          nowTaskId: this.taskId,
          questionId: this.questionId,
          taskDefKey: this.taskDefKey,
          auditText: this.form.rejectReason,
          variables: {
            approval: false,
          },
        };
        requestSubmitAuditKD(formData).then((res) => {
          if (res.status == "0") {
            this.$DonMessage.success("驳回成功!");
            this.backRouterPath();
            this.dialogVisible = false;
          } else {
            this.$DonMessage.error(res.message);
          }
        });
      });
    },
  },
  mounted() {
    if (this.suggestionItems) {
      this.form.suggestionItems = this.suggestionItems;
    }
  },
};
</script>
